/**
 * @desc 审核委托方发起的终止
 */
import { AuctionHaltAuditForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type AuditAuctionHaltParameter = AuctionHaltAuditForm

const method = 'POST'
const url = '/trade/operation/auction/halt/audit'

export const auditAuctionHaltApi = (
  data?: AuditAuctionHaltParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

auditAuctionHaltApi.method = method
auditAuctionHaltApi.url = url
